/* =========================================================
   Magnetify – поведение към Dawn 14
   Файл: assets/magnetify.js
   ========================================================= */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  /* Магнити, които „щракват“, когато влязат в екрана */
  function initSnap(root) {
    var items = (root || document).querySelectorAll('.mg-snap:not(.is-in)');
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (i) { i.classList.add('is-in'); });
      return;
    }
    /* Следим цялата решетка, а не отделните магнити – те започват извън екрана. */
    var groups = new Set();
    items.forEach(function (i) { groups.add(i.parentElement); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.querySelectorAll('.mg-snap').forEach(function (i) { i.classList.add('is-in'); });
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.2 });
    groups.forEach(function (g) { io.observe(g); });
  }

  /* Светлина след курсора (само с мишка) */
  function initGlow(root) {
    (root || document).querySelectorAll('[data-mg-glow]').forEach(function (el) {
      if (el.dataset.mgGlowReady) return;
      el.dataset.mgGlowReady = '1';
      el.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mx', ((e.clientX - r.left) / r.width) * 100 + '%');
        el.style.setProperty('--my', ((e.clientY - r.top) / r.height) * 100 + '%');
      });
    });
  }

  /* Лента до безплатна доставка на продуктовата страница */
  function updateShip(variantPrice) {
    document.querySelectorAll('[data-mg-ship]').forEach(function (el) {
      var threshold = parseInt(el.dataset.threshold, 10) || 3000;
      var cartTotal = parseInt(el.dataset.cartTotal, 10) || 0;
      var extra = variantPrice != null ? variantPrice : parseInt(el.dataset.extra, 10) || 0;
      var total = cartTotal + extra;
      var remaining = threshold - total;
      var pct = Math.max(0, Math.min(100, Math.round((total / threshold) * 100)));
      var text = el.querySelector('.mg-ship__text');
      if (text) {
        text.innerHTML = remaining > 0
          ? 'Още <strong>' + money(remaining) + '</strong> до безплатна доставка'
          : 'Имате безплатна доставка';
      }
      el.classList.toggle('is-done', remaining <= 0);
      var bar = el.querySelector('.mg-ship__bar');
      if (bar) {
        bar.setAttribute('aria-valuenow', pct);
        var fill = bar.querySelector('span');
        if (fill) fill.style.width = pct + '%';
      }
    });
  }

  /* Лента за покупка долу на телефона */
  function initSticky() {
    var bar = document.querySelector('[data-mg-sticky]');
    if (!bar) return;
    /* Преместваме лентата директно в <body>: вътре в продуктовата секция position: fixed не работи. */
    document.body.appendChild(bar);
    var watch = document.querySelector('.product-form__buttons') || document.querySelector('variant-selects');
    if (watch && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(watch);
    }
    var go = bar.querySelector('[data-mg-sticky-go]');
    if (go) {
      go.addEventListener('click', function () {
        var target = document.querySelector('.product__info-container .shopify-app-block') ||
          document.querySelector('.product-form__buttons') || watch;
        if (target) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      });
    }
  }

  /* Смяна на варианта: обновява цената в лентите */
  function initVariantUpdates() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var v = event && event.data && event.data.variant;
      if (!v) return;
      updateShip(v.price);
      var price = document.querySelector('[data-mg-sticky-price]');
      if (price) price.textContent = money(v.price);
      var title = document.querySelector('[data-mg-sticky-title]');
      if (title) title.textContent = v.title + (title.dataset.suffix || '');
    });
  }

  function init(root) {
    initSnap(root);
    initGlow(root);
  }

  init(document);
  updateShip(null);
  initSticky();
  initVariantUpdates();

  /* В редактора на темата: при добавяне или промяна на секция */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
